import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import {
  CheckoutV3GetPreferencesForLoyalties,
  CheckoutV3GetPreferencesForLoyaltiesVariables
} from './__generated__/CheckoutV3GetPreferencesForLoyalties'

export default function usePreferencesForLoyalties() {
  const websiteId = useWebsiteId()
  const {data} = useQuery<
    CheckoutV3GetPreferencesForLoyalties,
    CheckoutV3GetPreferencesForLoyaltiesVariables
  >({
    query: gql`
      query CheckoutV3GetPreferencesForLoyalties($websiteId: ID!) {
        preferences: userPreferences(websiteId: $websiteId) {
          _id
          user {
            _id
            name
            email
          }

          loyaltyProgram

          cart {
            itemsPrice
            loyaltyTransactionStatus {
              discount
              transactionId
              loyaltyName
            }
          }
          websiteId
        }
      }
    `,
    variables: {
      websiteId
    },
    fetchPolicy: 'cache-first'
  })

  return data
}
